import {CommonApp} from '../../app.js';

CommonApp.module.service('hybrisProductPricingService', ['$http', '$q', function($http, $q) {
    // ---------------------------------------------------------------------------
    //
    //                           Public Methods
    //
    // ---------------------------------------------------------------------------
    //
    //  THIS SERVICE WILL BE DEPRECATED SOON.  WE WILL NOT BE USING THE PRICING
    //  FROM HYBRIS.
    //
    // ---------------------------------------------------------------------------
    this.priceProducts = function(skuArray) {
        var skus = '';

        for (var i=0; i< skuArray.length; i++) {
            skus += skuArray[i];

            if (i < skuArray.length) {
                skus += ',';
            }
        }

        return $http.post('https://testgw.mynuskin.com/token/api/v2/nuskin_us/users/' +
            'anonymous/prices/multiple/all?productCodes=' + skus);
    };
}]);

CommonApp.module.service('aemProductPricingService', ['$http', '$q', function($http, $q) {
    // ---------------------------------------------------------------------------
    //
    //                           Public Methods
    //
    // ---------------------------------------------------------------------------
    this.priceProducts = function(skuArray, country) {
        // console.log(skuArray);

        var promises = skuArray.map(function(sku) {
            return $http.get('https://www.nuskin.com/content/products.productSearch.png/'
                + sku + '/' + country + '/en/WRTL/26/1');
        });

        return $q.all(promises);
    };
}]);



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/angular/services/productPricing/service.js
// module id = 276
// module chunks = 0